var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEntitykyc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(-20 -65)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    transform: "translate(20 65)",
    fill: "#ff4100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "download_6_",
    "data-name": "download (6)",
    d: "M253.6,183.61V189a1.794,1.794,0,0,0,1.8,1.795h4.486v15.273a1.791,1.791,0,0,1-1.794,1.794H244.612a1.8,1.8,0,0,1-1.794-1.8V185.414a1.8,1.8,0,0,1,1.8-1.8H253.6Zm.9,0V189a.9.9,0,0,0,.89.9h4.5ZM250,193.491v.9h7.186v-.9Zm-4.492-.9v2.695h2.695v-2.695Zm.9.9v.9h.9v-.9Zm-.9,3.593v2.695h2.695v-2.695Zm.9.9v.9h.9v-.9Zm3.593,0v.9h7.186v-.9Zm-4.492,3.593v2.695h2.695v-2.695Zm.9.9v.9h.9v-.9Zm3.593,0v.9h7.186v-.9Z",
    transform: "translate(-211.35 -110.949)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntitykyc);
export default __webpack_public_path__ + "static/media/entitykyc.b87e2f6d125653e22cc44a2be07a84dd.svg";
export { ForwardRef as ReactComponent };